// @ts-nocheck
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { useMemo } from "react";

const useExtractCartLineConfigurableChildrenToArray = (cartLines: CartLineModel[]) => {
    return useMemo(() => {
        if (!cartLines) {
            return [];
        }

        return cartLines.reduce((acc: any[], line: CartLineModel) => {
            line.sectionOptions?.forEach((option: any) => {
                if (option.optionName === "Empty" || option.productId === null) {
                    return;
                }
                const kits: any[] = JSON.parse(line.properties.productsInKit);
                if (!kits || kits.length === 0) {
                    return;
                }
                const currentKit = kits.find((item: any) => item.ProductId === option.productId);
                if (currentKit) {
                    const existingOption = acc.find(item => item.productId === currentKit.ProductId);
                    if (existingOption) {
                        existingOption.qtyOrdered += line.qtyOrdered || 0;
                    } else if (currentKit.ProductId && line.qtyOrdered) {
                        acc.push({
                            productId: currentKit.ProductId,
                            erpNumber: currentKit.ProductSku,
                            qtyOrdered: line.qtyOrdered,
                            unitOfMeasure: line.unitOfMeasure,
                            uri: currentKit.ProductUrl,
                        });
                    }
                }
            });
            return acc;
        }, []);
    }, [cartLines]);
};

export default useExtractCartLineConfigurableChildrenToArray;
